module.exports = __webpack_public_path__ + "img/onlineService.7dbe5eb1.png";